import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import Select from 'react-select';
import SecCard from "../../components/common/SecCard";
import Loader from "../../components/common/Loader";
import HeaderCard from "../../components/common/HeaderCard";
import BackButton from "../../components/common/BackButton";
import { Country, State, City } from 'country-state-city';
import { SERVER_ORIGIN, validation } from "../../utilities/constants";
import css from "../../css/chapterEM/add-chapterEM.module.css";

const AddRegionEM = () => {
  const navigate = useNavigate();
  // const { userId } = useParams();
  // const isEditMode = Boolean(userId);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isEditMode = queryParams.get("edit") === "true";
  // const { id: userId } = useParams();
  const userId = queryParams.get("id"); // ✅ Get id from query params


  const [regionEMForm, setRegionEMForm] = useState({
    name: "",
    email: "",
    region: "",
    mobile_no: "",
    role: "Regional Mentor",
    regionEMfor: ""
    // country: "India",
    // state: "",
    // city: "",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [regions, setRegions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  useEffect(() => {

    async function canVisitPage() {
      setIsLoading(true);
      try {
        const currentUserType = sessionStorage.getItem("userType");
        let verifyEndpoint = "";
        let headers = {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        };

        if (currentUserType === "admin") {
          verifyEndpoint = `${SERVER_ORIGIN}/api/admin/auth/verify-token`;
          const adminId = process.env.REACT_APP_ADMIN_ID;
          const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
          const basicAuth = btoa(`${adminId}:${adminPassword}`);
          headers.Authorization = `Basic ${basicAuth}`;
        } else if (currentUserType === "regionem") {
          verifyEndpoint = `${SERVER_ORIGIN}/api/regionem/auth/verify-token`;
        } else {
          navigate("/login");
          return;
        }

        const response = await fetch(verifyEndpoint, {
          method: "POST",
          headers: headers,
        });

        const result = await response.json();

        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate(`/login?userType=${currentUserType}`);
          } else {
            toast.error(result.statusText);
          }
        }
      } catch (err) {
        console.log(err.message);
        navigate("/login");
      }
      setIsLoading(false);
    }
    // Initialize country, states and fetch regions
    const initializeLocationData = () => {
      // Set default country to India
      const indiaCountry = Country.getCountryByCode('IN');
      setSelectedCountry(indiaCountry);

      // Get all states for India
      const indiaStates = State.getStatesOfCountry('IN').map(state => ({
        value: state.isoCode,
        label: state.name,
        name: state.name
      }));
      setStates(indiaStates);
    };

    // Fetch regions for dropdown
    async function fetchRegions() {
      try {
        const response = await fetch(`${SERVER_ORIGIN}/api/region/auth/get-all`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
          },
        });
        const result = await response.json();
        if (response.status === 200) {
          const regionOptions = result.filteredRegions.map(region => ({
            value: region.name,
            label: region.name
          }));
          setRegions(regionOptions);
        }
      } catch (err) {
        console.error("Error fetching regions:", err);
      }
    }

    initializeLocationData();
    fetchRegions();
    canVisitPage();


    // If edit mode, fetch existing data
    if (isEditMode) {
      fetchRegionEMData();
    }
  }, [isEditMode, userId]);

  // Update cities when state changes
  useEffect(() => {
    if (selectedState && selectedCountry) {
      const stateCities = City.getCitiesOfState(selectedCountry.isoCode, selectedState.value).map(city => ({
        value: city.name,
        label: city.name
      }));
      setCities(stateCities);
    } else {
      setCities([]);
    }
  }, [selectedState, selectedCountry]);

  const fetchRegionEMData = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${SERVER_ORIGIN}/api/regionem/auth/${userId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        },
      }); console.log("sdjsbfhdsf::>>>>>", response);
      const result = await response.json();
      if (response.status === 200) {
        const userData = result.user;
        setRegionEMForm({
          name: userData.name || "",
          email: userData.email || "",
          region: userData.region || "",
          mobile_no: userData.mobile_no || "",
          role: userData.role || "Regional Mentor",
          country: userData.country || "India",
          state: userData.state || "",
          city: userData.city || "",
        });

        // Set selected state and city for dropdowns
        if (userData.state) {
          const state = states.find(s => s.name === userData.state || s.label === userData.state);
          if (state) {
            setSelectedState(state);
          }
        }
      } else {
        toast.error("Failed to fetch Regional Mentor data");
        navigate("/region-em/all");
      }
    } catch (err) {
      toast.error("Error fetching Regional Mentor data");
      navigate("/region-em/all");
    }
    setIsLoading(false);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setRegionEMForm({ ...regionEMForm, [name]: value });

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const onRegionChange = (selectedOption) => {
    setRegionEMForm({
      ...regionEMForm,
      region: selectedOption ? selectedOption.value : ""
    });
    if (errors.region) {
      setErrors({ ...errors, region: "" });
    }
  };

  const onStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
    setRegionEMForm({
      ...regionEMForm,
      state: selectedOption ? selectedOption.name || selectedOption.label : "",
      city: "" // Reset city when state changes
    });
    if (errors.state) {
      setErrors({ ...errors, state: "" });
    }
  };

  const onCityChange = (selectedOption) => {
    setRegionEMForm({
      ...regionEMForm,
      city: selectedOption ? selectedOption.value : ""
    });
    if (errors.city) {
      setErrors({ ...errors, city: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let missingFields = [];

    // Email regex pattern
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Required field validation
    if (!regionEMForm.name.trim()) {
      newErrors.name = "Name is required";
      missingFields.push("name");
    }

    if (!regionEMForm.email.trim()) {
      newErrors.email = "Email is required";
      missingFields.push("email");
    } else if (!emailRegex.test(regionEMForm.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!regionEMForm.region.trim()) {
      newErrors.region = "Region is required";
      missingFields.push("region");
    }

    if (!regionEMForm.mobile_no.trim()) {
      newErrors.mobile_no = "Mobile number is required";
      missingFields.push("mobile number");
    } else if (!/^[0-9]{10}$/.test(regionEMForm.mobile_no)) {
      newErrors.mobile_no = "Mobile number must be exactly 10 digits";
    }

    if (!regionEMForm.role.trim()) {
      newErrors.role = "Role is required";
      missingFields.push("role");
    }

    if (!regionEMForm.regionEMfor.trim()) {
      newErrors.regionEMfor = "EM for is required";
      missingFields.push("regionEMfor");
    }

    setErrors(newErrors);

    if (missingFields.length > 0) {
      toast.error(`Please fill in all required fields: ${missingFields.join(", ")}`);
    }

    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const url = isEditMode
        ? `${SERVER_ORIGIN}/api/regionem/auth/update-user/${userId}`
        : `${SERVER_ORIGIN}/api/regionem/auth/register`;

      const method = "POST";

      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        },
        body: JSON.stringify(regionEMForm),
      });

      const result = await response.json();
      setIsLoading(false);

      if (response.status === 200) {
        toast.success(
          isEditMode
            ? "Regional Mentor updated successfully!"
            : "Regional Mentor added successfully!"
        );
        navigate("/region-em/all");
      } else {
        toast.error(result.statusText || `Failed to ${isEditMode ? 'update' : 'add'} Regional Mentor`);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(
        `Error ${isEditMode ? "updating" : "adding"} Regional Mentor`
      );
    }
  };

  const onReset = () => {
    setRegionEMForm({
      name: "",
      email: "",
      region: "",
      mobile_no: "",
      role: "Region EM",
      // country: "India",
      // state: "",
      // city: "",
    });
    setSelectedState(null);
    setErrors({});
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={css.outerDiv}>
      <HeaderCard>
        <BackButton
          text="Back to Regional Mentor"
          customPath="/region-em/all"
        />
        <h1 className="headerTitle">
          {isEditMode ? "Edit Regional Mentor" : "Add Regional Mentor"}
        </h1>
        <hr />
        <p className="headerSubtitle">
          {isEditMode
            ? "Update the Regional Mentor details below"
            : "Fill in the details to add a new Regional Mentor"}
        </p>
      </HeaderCard>

      <SecCard>
        <form onSubmit={onSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="name" className="form-label">
                Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                id="name"
                name="name"
                value={regionEMForm.name}
                onChange={onChange}
                placeholder="Enter full name"
              />
              {errors.name && (
                <div className="invalid-feedback">{errors.name}</div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label htmlFor="email" className="form-label">
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                id="email"
                name="email"
                value={regionEMForm.email}
                onChange={onChange}
                placeholder="Enter email address"
                disabled={isEditMode} // Don't allow email change in edit mode
              />
              {errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="region" className="form-label">
                Region <span className="text-danger">*</span>
              </label>
              <Select
                options={regions}
                value={regions.find(
                  (option) => option.value === regionEMForm.region
                )}
                onChange={onRegionChange}
                placeholder="Select Region"
                isClearable
                className={errors.region ? "is-invalid" : ""}
              />
              {errors.region && (
                <div className="text-danger small mt-1">{errors.region}</div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label htmlFor="mobile_no" className="form-label">
                Mobile Number <span className="text-danger">*</span>
              </label>
              <input
                type="tel"
                className={`form-control ${errors.mobile_no ? "is-invalid" : ""
                  }`}
                id="mobile_no"
                name="mobile_no"
                value={regionEMForm.mobile_no}
                onChange={onChange}
                placeholder="Enter 10-digit mobile number"
                maxLength="10"
              />
              {errors.mobile_no && (
                <div className="invalid-feedback">{errors.mobile_no}</div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="role" className="form-label">
                Role <span className="text-danger">*</span>
              </label>
              <select
                className={`form-control ${errors.role ? "is-invalid" : ""}`}
                id="role"
                name="role"
                value={regionEMForm.role}
                onChange={onChange}
                required
              >
                <option value="">Select Role</option>
                {/* <option value="Admin">Admin</option> */}
                <option value="Regional Mentor">Regional Mentor</option>
              </select>
              {errors.role && (
                <div className="invalid-feedback">{errors.role}</div>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="regionEMfor" className="form-label">
                Regional Mentor For (YUVA or THALIR) <span style={{ color: "red" }}>*</span>
              </label>
              <select
                className={`form-control ${errors.regionEMfor ? "is-invalid" : ""}`}
                id="regionEMfor"
                name="regionEMfor"
                value={regionEMForm.regionEMfor}
                onChange={onChange}
                required
              >
                <option value="">Select...</option>
                <option value="YUVA">YUVA</option>
                <option value="THALIR">THALIR</option>
              </select>
              {/* <label className={css.instiLabel} htmlFor="createdBy">
                                        Chapter EM Name <span style={{ color: "red" }}>*</span>
                                    </label> */}
              {/* <AsyncSelect
                                        cacheOptions
                                        loadOptions={loadOptions}
                                        defaultOptions={defaultOptions}
                                        onChange={handleEMChange}
                                        value={selectedEM}
                                        placeholder="Select..."
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: errors.createdBy ? '#dc3545' : (state.isFocused ? '#007bff' : '#ced4da'),
                                                '&:hover': {
                                                    borderColor: errors.createdBy ? '#dc3545' : '#007bff'
                                                }
                                            })
                                        }}
                                    />
                                    {errors.createdBy && <small className="text-danger">{errors.createdBy}</small>} */}
            </div>

            {/* <div className="col-md-6 mb-3">
                            <label htmlFor="country" className="form-label">
                                Country
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="country"
                                name="country"
                                value={regionEMForm.country}
                                onChange={onChange}
                                placeholder="Enter country"
                                disabled // Keep country as India for now
                            />
                        </div> */}
          </div>

          {/* <div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="state" className="form-label">
                                State
                            </label>
                            <Select
                                options={states}
                                value={selectedState}
                                onChange={onStateChange}
                                placeholder="Select State"
                                isClearable
                                className={errors.state ? 'is-invalid' : ''}
                            />
                            {errors.state && (
                                <div className="text-danger small mt-1">{errors.state}</div>
                            )}
                        </div>

                        <div className="col-md-6 mb-3">
                            <label htmlFor="city" className="form-label">
                                City
                            </label>
                            <Select
                                options={cities}
                                value={cities.find(option => option.value === regionEMForm.city)}
                                onChange={onCityChange}
                                placeholder="Select City"
                                isClearable
                                isDisabled={!selectedState}
                                className={errors.city ? 'is-invalid' : ''}
                            />
                            {errors.city && (
                                <div className="text-danger small mt-1">{errors.city}</div>
                            )}
                            {!selectedState && (
                                <div className="text-muted small mt-1">Please select a state first</div>
                            )}
                        </div>
                    </div> */}

          <div className="row mt-4">
            <div className="col-12 d-flex justify-content-center gap-3">
              <button
                type="submit"
                className="btn btn-success px-4"
                disabled={isLoading}
              >
                {isLoading
                  ? `${isEditMode ? "Updating" : "Adding"}...`
                  : `${isEditMode ? "Update" : "Add"} Regional Mentor`}
              </button>

              {!isEditMode && (
                <button
                  type="button"
                  className="btn btn-secondary px-4"
                  onClick={onReset}
                  disabled={isLoading}
                >
                  Reset
                </button>
              )}

              <button
                type="button"
                className="btn btn-outline-secondary px-4"
                onClick={() => navigate("/region-em/all")}
                disabled={isLoading}
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </SecCard>
    </div>
  );
};

export default AddRegionEM; 